<h1>Hello {{loggedUserfirstName}}!</h1>
<div class="row">
  <div class="col-lg-6 col-md-12">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Welcome to {{generalSettings?.businessFullName}} client portal.</h5>
        <div *ngIf="patients == null">
          Loading registered patients...
        </div>
        <div *ngIf="patients != null">
          <h6>
            Click a name below to access your available client information.
          </h6>
          <h6 class="">Registered patients:</h6>

          <ul>
            <li *ngFor="let patient of patients">
              <a [routerLink]="['/patient/'+ patient.inquiryID ]"
                 class=""
                 [ngClass]="{
            'text-danger': this.hasActionRequired(patient)
          }">
                {{getPatientDisplayName(patient)}}  {{patient.birthdate | date: 'M/d/yy'}}
                <span *ngIf="hasActionRequired(patient)" class="text-danger">[Action Required]</span>
              </a>
              <div *ngIf="patient.hasOptumMedicaid">
                <p>
                  Our records indicate you have Optum Medicaid as an insurance provider.
                  <a href="https://optumhealthslco.com/" target="_blank">View your Medicaid Member Handbook HERE by looking under the section "Medicaid Member Handbook.</a>
                </p>

                Within this handbook you can find information regarding but not limited to:
                <ol>
                  <li>Emergency Services</li>
                  <li>Transportation</li>
                  <li>Choosing a sub-contractor</li>
                  <li>Filing grievances and appeals</li>
                </ol>
                <p>
                  Please call 801-255-5131 and allow 5 business days for a printed copy.
                </p>
              </div>
            </li>
          </ul>
          <!--<a class="btn btn-primary" [routerLink]="['/patient/add']" >Add patient</a>-->
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-6 col-md-12 mt-md-3 mt-lg-0" *ngIf="canMakePayment && patients != null ">
    <div class="card">
      <div class="card-body">
        <div class="text-center">
          <h6>
            Do you have an upcoming appointment, and want to pay your copay now?
          </h6>
          <h6>
            Click below to make that payment.
          </h6>
        </div>
        <div class="mt-3 text-center">
          <button class="btn btn-primary m-3" [routerLink]="['/client/payment']">Pay Copay</button>
        </div>
      </div>
    </div>
  </div>

  <!-- CURRENT NOTICES -->
  <div class="col-12 m-0 p-0">
    <app-notices></app-notices>
  </div>

  <div class="col-12 mt-3" *ngIf="openPatientInvoices!=null && openPatientInvoices.length>0">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Outstanding Invoices</h5>
        <table class="table table-striped ">
          <thead>
            <tr>
              <th>
                Invoice #
              </th>
              <th class="d-none d-md-table-cell text-center">Date</th>
              <th class="text-center">Due</th>
              <th class="d-none d-xl-table-cell">
                Account
              </th>
              <th class="d-none d-lg-table-cell">
                Patient
              </th>
              <th class="text-right">
                Amount
              </th>
              <th class="text-right">
                Due
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let inv of openPatientInvoices">
              <td>
                <a *ngIf="inv.canViewInvoice" href="#" [routerLink]="['/client/invoice/'+  inv.patientInvoiceID ]" [class.button-loading]="inv.invoiceDownloading" title="Download PDF">
                  {{inv.invoiceNumber}}
                  <i class="fal fa-file-pdf ml-1"></i>
                </a>
                <span *ngIf="!inv.canViewInvoice">{{inv.invoiceNumber}}</span>
              </td>
              <td class="d-none d-md-table-cell text-center">
                {{inv.invoiceDate | date}}
              </td>
              <td class="text-center" [class.text-danger]="isPastDue(inv.invoiceDueDate, inv.patientInvoiceStatusID)" [class.text-info]="isInPaymentPlan(inv.patientInvoiceStatusID)">
                {{inv.invoiceDueDate | date}}
                <i class="fal fa-comment-alt-exclamation" *ngIf="isPastDue(inv.invoiceDueDate, inv.patientInvoiceStatusID)" title="Past due"></i>
                <i class="fas fa-calendar-check" *ngIf="isInPaymentPlan(inv.patientInvoiceStatusID)" title="Invoice has an active payment plan"></i>
              </td>
              <td class="d-none d-xl-table-cell">
                <a class="" [routerLink]="['/client/account/'+ inv.patientResponsibilityAccountID]" title="View Account">
                  {{inv.patientResponsibilityAccountName}}
                </a>
              </td>
              <td class="d-none d-lg-table-cell">
                <div *ngFor="let p of inv.patientNames">
                  {{p}}
                </div>
              </td>
              <td class="text-right">
                {{inv.totalAmount | currency }}
              </td>
              <td class="text-right">
                <a class=" ml-3" *ngIf="canMakePayment && inv.amountDue>0" [routerLink]="['/client/payment']" [queryParams]="{invoiceNumber:inv.invoiceNumber, amount: inv.amountDue, patientResponsibilityAccountID: inv.patientResponsibilityAccountID}" title="Make Payment">
                  {{inv.amountDue | currency }}
                  <i class="fal fa-credit-card-front ml-1"></i>
                </a>
                <span *ngIf="!canMakePayment && inv.amountDue>0">
                  {{totalAmountDue | currency }}
                </span>
                <span *ngIf="inv.amountDue<=0">-</span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td class="d-none d-md-table-cell">
              </td>
              <td class="d-none d-lg-table-cell">
              </td>
              <td class="d-none d-xl-table-cell">
              </td>
              <td colspan="2">
              </td>
              <td class="text-right font-weight-bold" colspan="2">
                Total Amount Due:
                <a class=" ml-3" *ngIf="canMakePayment && totalAmountDue>0" [routerLink]="['/client/payment']" [queryParams]="{amount: totalAmountDue}" title="Make Payment">
                  {{totalAmountDue | currency }}
                  <i class="fal fa-credit-card-front ml-1"></i>
                </a>
                <span *ngIf="!canMakePayment && totalAmountDue>0">
                  {{totalAmountDue | currency }}
                </span>
                <span *ngIf="totalAmountDue<=0">-</span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>

  <div class="col-12 mt-3" *ngIf="paymentSchedule!=null && paymentSchedule.length>0">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Schedule Payments</h5>
        <table class="table table-striped ">
          <thead>
            <tr>
              <th class="text-center">
                #
              </th>
              <th class="text-center">
                Date
              </th>
              <th class="text-right">
                Amount
              </th>
              <th class="text-center">
                Payment Plan
              </th>
              <th >
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let sch of paymentSchedule">
              <th class="text-center">
                {{sch.paymentNr}}
              </th>
              <td class="text-center">
                {{sch.dueDate | date}}
              </td>
              <td class="text-right">
                {{sch.dueAmount | currency }}
              </td>
              <td class="text-center">
                <a  href="#" [routerLink]="['/client/account/'+  sch.patientResponsibilityAccountID ]">
                  {{ getPaymentPlanFrequency(sch) }}
                </a>
              </td>
              <td>
                <span *ngIf="(!sch.formSubmissionID || sch.signedDate) && !sch.paymentErrorMessage">
                  {{sch.paymentPlanScheduleStatus}}
                </span>
                <span *ngIf="sch.paymentErrorMessage" class="text-danger">
                  {{sch.paymentErrorMessage}}
                </span>
                <a href="#" [routerLink]="['/client/receipt/'+  sch.cardConnectTransactionID ]" *ngIf="sch.cardConnectTransactionID">
                  {{sch.retref}}
                  <i class="fal fa-file-pdf ml-1"></i>
                </a>
                <a class="text-danger font-weight-bolder" *ngIf="sch.formSubmissionID && !sch.signedDate" href="#" [routerLink]="['/patient/0/forms/fill/'+  sch.formID +'/'+sch.formSubmissionID ]">
                  You are required to sign the payment plan agreement
                </a>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td class="text-right font-weight-bold" colspan="3">
                Total Scheduled Amount:
                <span *ngIf="totalScheduledAmount>0">
                  {{totalScheduledAmount| currency }}
                </span>
                <span *ngIf="totalScheduledAmount<=0">-</span>
              </td>
              <td>
              </td>

            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>

  <!-- MESSAGING -->
  <div class="col-12 mt-3" *ngIf="canSendReceiveMessage && unreadThreads !=null && unreadThreads.length > 0">
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between">
          <h5 class="m-1">Unread messages</h5>
          <button class="btn btn-primary align-top d-none" [routerLink]="['/messaging/message-send']">New Message</button>
          <button class="btn btn-primary align-top d-none" [routerLink]="['/messaging/message-list']">Message List</button>
        </div>
        <div class="m-0 p-0 unreadThread" *ngFor="let messageThread of unreadThreads">

          <a href="#" class="list-group-item list-group-item-action" [routerLink]="['/messaging/message-view/'+messageThread.messageThreadID]">
            <div class="float-right">
              {{messageThread.date | date:'short'}}
            </div>
            <img *ngIf="messageThread.patientPhotoID !=null" [src]="urlForPictureRequest + messageThread.patientPhotoID | secure | async" class="item-profile-photo" style="float:left; margin-right: 5px; margin-top:5px;" />
            <div class="font-weight-bolder" title="Patient Name">{{messageThread.patientName}}</div>
            <span *ngIf="messageThread.unread>0" class="float-right  badge  badge-pill badge-success " title="Has unread messages">{{messageThread.unread}}</span>
            <div>{{messageThread.threadName}}</div>
          </a>

        </div>

      </div>
    </div>
  </div>
